const SIDEBAR_SELECTOR = "[data-heads-up-sidebar]";

/**
 * Returns a DOMRect that aligns the hover preview reference with the sidebar's left edge
 * while preserving the hovered element's vertical position and height.
 */
export function getHeadsUpSidebarAnchorRect(target: HTMLElement): DOMRect {
  const elementRect = target.getBoundingClientRect();
  const sidebar = target.closest(SIDEBAR_SELECTOR) as HTMLElement | null;

  if (!sidebar) {
    return elementRect;
  }

  const sidebarRect = sidebar.getBoundingClientRect();
  let sidebarPaddingLeft = 0;

  try {
    const computed = window.getComputedStyle(sidebar);
    const parsed = parseFloat(computed.paddingLeft || "0");
    sidebarPaddingLeft = Number.isFinite(parsed) ? parsed : 0;
  } catch {
    sidebarPaddingLeft = 0;
  }

  const anchorLeft = sidebarRect.left + sidebarPaddingLeft;
  const anchorWidth = Math.max(elementRect.right - anchorLeft, 1);

  return new DOMRect(anchorLeft, elementRect.top, anchorWidth, elementRect.height);
}
